export enum SortDirections {
  ascending = 'asc',
  descending = 'desc',
}
